import { Injectable, inject } from '@angular/core';
import { filter, firstValueFrom, take, timeout } from 'rxjs';
import { BusinessContextService } from '../services/multi-tenant/business-context.service';
import { NoBusinessSelectedError } from './tenant-collection';

/**
 * Single source of truth for resolving the active Business id — replaces the 4
 * incompatible `getCurrentBusinessId()` variants scattered across services.
 *
 * Behavior: wait briefly for the first non-null businessId (covers the app-startup
 * race), then THROW. Never wait forever — a hung read is the silent-failure mode
 * we explicitly want to avoid.
 */
@Injectable({ providedIn: 'root' })
export class BusinessIdResolver {
  private businessContext = inject(BusinessContextService);

  async require(timeoutMs = 5000): Promise<string> {
    try {
      return await firstValueFrom(
        this.businessContext.currentBusinessId$.pipe(
          filter((id): id is string => !!id),
          take(1),
          timeout({ first: timeoutMs })
        )
      );
    } catch {
      throw new NoBusinessSelectedError();
    }
  }
}
